<template>
  <div class="index">
    
    <topNav></topNav>
    
    <div class="top" :style="{'background-image':'url(static/news_top_bg.png)','position':'relative','width':'100%','height':'600px','background-size':'auto 100%','background-position':'0px 0px'}" >
      
 
    


        <div class="top" :style="{'background-image':'url('+nameType[curType].bg+')','position':'relative','width':'100%','height':'600px','background-size':'auto 100%','background-position':'0px 0px'}" >
      <ul class="about_us_nav">
        <li @click="showNameType(0)" :class="[curType==0?'itemActive':'itemNoActive']">{{nameType[0].name}}</li>
        <li @click="showNameType(1)" :class="[curType==1?'itemActive':'itemNoActive']">{{nameType[1].name}}</li>
        <li @click="showNameType(2)"   :class="[curType==2?'itemActive':'itemNoActive']">{{nameType[2].name}}</li>
        <li @click="showNameType(3)" :class="[curType==3?'itemActive':'itemNoActive']" style="font-size:11px;">{{nameType[3].name}}</li>
     </ul>    
    </div>

   
    </div>


             <!--<img src="static/china_real_estate_industry_green_supply_chain_action.png" style="position:absolute;left:25px;top:150px;width:50%;" />-->
    <div style="position:absolute;left:25px;top:150px;width:68%;text-align:left;" class="brief_1 Impact" >Green Supply Chain Action in China’s Real Estate Industry</div>

    <!--<img src="static/under_top_logo.png" style="position:absolute;left:25px;top:200px;width:150px;" />-->

    <div style="position:absolute;left:25px;top:260px;width:55%;text-align:left;" class="brief_1 Impact"  v-if="$store.state.language === 'cn'">中国房地产行业<br/>绿色供应链行动</div>




 
    <pageLocation :currentLocation="nameType[curType].name"></pageLocation>
 
    <div class="aboutUs" style="width:100%;height:auto;margin:120px auto 0px auto;" >
      <!-- aboutUs start -->
      <div >
     <div style="width:80%;margin:0 auto"><div style="width:80%;display:block;margin:0 auto;color:#57802b"  class="brief_1 Impact">{{nameType[curType].enTitle}}</div></div>
     <div style="width:80%;margin:0 auto"><div style="width:80%;display:block;margin:10px auto auto auto;color:#57802b"  class="brief_1 Impact"  v-if="$store.state.language === 'cn'">{{nameType[curType].chTitle}}</div></div>
     </div> 
 
 

     
     <div style="width:80%;margin:20px auto" v-if="curType == 0">
         <div style="text-align:left;" v-html="lscgznContent.content" ></div> 
         
 
     </div>
  



     
     <div style="width:80%;margin:20px auto;border-top:1px solid #628838" v-if="curType != 0">
         <!--名单列表-->
         <ul class="newsItem" v-for="(nameItem,index) in supplierList.list" :key="index">
           <li style="float:left;margin-top:10px;width:20%;">
             <div style="text-align:center;font-weight:700;font-size:20px;color:#57802b;font-family:'SourceHanSansCN,Microsoft Yahei,微软雅黑,verdana'">{{nameItem.createdat.substring(5,10)}}</div>
             <div style="text-align:center;">{{nameItem.createdat.substring(0,4)}}</div>
             <div style="text-align:center;">{{nameItem.authorName}}</div>
             </li>
              <li style="float:left;text-align:left;margin-top:10px;margin-bottom:10px;width:50%;">{{nameItem.articleName}}</li>
              <li @click="showOrHideDetail(nameItem.articleId,$event,nameItem.channelId)" style="float:left;margin-top:10px;border:1px solid #8fa926;border-radius:10px;color:#8fa926;width:20px;height:20px;line-height:20px;font-size:20px;">+</li>
              <div style="width:100%;height:2px;clear:both;"></div>
              <!-- <li class="detailContent" :id="nameItem.articleCode" style="width:95%;display:none;text-align:left;" v-html="nameItem.content.replaceAll('/uploadfile','http://gsc.see.org.cn/uploadfile')"></li> -->
              <li class="detailContent" :id="nameItem.id" style="width:95%;display:none;text-align:left;">
                <!--应该是附件-->
              </li>
              <li class="detailContent" :id="nameItem.articleId" style="width:95%;display:none;text-align:left;" v-html="nameItem.content"></li>
         


         </ul>
         
     </div>

 
 
  <!--aboutUs end-->
      </div>

 
  
    <!--底部组件-->
    <friendLinkAndFooter></friendLinkAndFooter>

 
 
  </div>
</template>


<script>
import { articleListByPage,articleDetail } from "@/api";
import Swiper from 'swiper'
import 'swiper/dist/css/swiper.min.css'
import friendLinkAndFooter from '@/components/friendLinkAndFooter'
import topNav from '@/components/topNav'
import pageLocation from '@/components/pageLocation'
export default {
  name: 'greenGuide',
  components:{
   topNav,friendLinkAndFooter,pageLocation
  },
  data () {
    return {
      msg: 'Welcome to Your Vue.js App',
      showNav:false,
      pages:1,
      curType:0,
      lscgznContent:'',

      nameType:[
        {'name':'绿色采购指南','articleCode':'WZNR201610311925050025','catCode':'','bg':'static/gysbmd_top_bg.png','enTitle':"Green Procurement Guide For China's Real Estate Industry",'chTitle':'中国房地产行业绿色采购指南'},
        {'name':'白名单评审规则','articleCode':'','catCode':'000003|000036','articleList':[],'bg':'static/gysbmd_top_bg.png','enTitle':'GSC Action White List Criterion','chTitle':'绿色供应链白名单评审规则'},
        {'name':'绿名单评审规则','articleCode':'','catCode':'000003|000040','bg':'static/gysbmd_top_bg.png','enTitle':'GSC Action Green List Criterion','chTitle':'绿色供应链绿名单评审规则'},
        {'name':'黑名单评审规则','articleCode':'','catCode':'000003|000041','bg':'static/gysbmd_top_bg.png','enTitle':'GSC Action Black List Criterion','chTitle':'绿色供应链黑名单评审规则'},
      ], 
 
      catCode:'000004|000023',
      supplierList:[]
    }
  },
  methods :{


          showNameType(n){
         this.curType=n;
         this.catCode=this.nameType[n].catCode;
          //查询各名单下的文章列表
          if(n != 0){
              this.articleListByPage(this.nameType[n].catCode);
          }else{

            const params = {
                      articleId: this.nameType[n].articleCode,
                      isEn: this.$store.state.language === 'en' ? 1 : 0
                    }
                    articleDetail(params).then((res) => {
                      // console.log(res); 
                        this.lscgznContent=res.data; 
                      // this.list = [res.data]
                      // this.content = 


                    setTimeout(() => {

                      var o=document.querySelectorAll('.detailContent img');
                  
                        if(o){
                          for(var i=0;i<o.length;i++){
                            o[i].setAttribute("style","width:100%")
                          }
                        }
                          
                        }, 1000);



                    })



          }
      },

 


    showOrHideDetail(articleCode,event,channelId){
      var that=this;
      if(event.target.innerHTML=='+'){
        // if(that.catCode=='000004|000022'){

          that.articleDetail(articleCode);

        // }
        document.getElementById(articleCode).setAttribute("style", "display:block;text-align:left;")
        document.getElementById(articleCode+''+channelId).setAttribute("style", "display:block;text-align:left;")
        event.target.innerHTML='-';


                    setTimeout(() => {

                      var o=document.querySelectorAll('.detailContent img');
                  
                        if(o){
                          for(var i=0;i<o.length;i++){
                            o[i].setAttribute("style","width:100%")
                          }
                        }
                          
                        }, 1000);



      }else{
         document.getElementById(articleCode+''+channelId).setAttribute("style", "display:none")
        document.getElementById(articleCode).setAttribute("style","display:none")
        event.target.innerHTML='+';
      }

    },


    articleDetail(articleCode){
      const params = {
          articleId: articleCode,
          isEn: this.$store.state.language === 'en' ? 1 : 0
        }
        articleDetail(params).then((res) => {
          // console.log(res);
          let articleFileList = res.data.nodeVoList;
          if(articleFileList){
            var fileHtml="";
            for(var i=0;i<articleFileList.length;i++){
                 fileHtml+="附件"+(i+1)+"：<a href='http://gsc.see.org.cn/file/file/api/download?nodeId="+articleFileList[i].noteId+"' >"+articleFileList[i].nodeName+"</a><br/>"
            }
             document.getElementById(articleCode+''+res.data.channelId).innerHTML=fileHtml;
          }else{
          document.getElementById(articleCode+''+res.data.channelId).setAttribute("style", "display:none")
          document.getElementById(articleCode).setAttribute("style", "display:none")
          }
          // this.list = [res.data]
          // this.content = 
        })

    },

   articleListByPage(catCode,year) {
        var that=this
            // console.log(this.dateY,' =====____');
            const params = {
              page: that.pages,
              catCode: encodeURIComponent(catCode),
              year:year,
              limit:99999,
              isEn: this.$store.state.language === 'en' ? 1 : 0
            };
            articleListByPage(params).then(res => {
              let _list = res.data.list;
              for(let k=0;k<_list.length;k++){
                _list[k].id = _list[k].articleId+''+ _list[k].channelId
              }
              res.data.list = _list;
              this.supplierList = res.data;
              if(0 <_list.length){
                this.articleDetail(_list[0].articleId)
              }
            });
          }
  },
   mounted() {
     var that=this;

     that.curType=this.$route.query.mdType;
 
      //加载新闻
      if(that.curType!=0){
                this.articleListByPage(this.catCode,'') 
          
                setTimeout(() => {

              var o=document.querySelectorAll('.detailContent table');
          
                if(o){
                  for(var i=0;i<o.length;i++){
                    o[i].setAttribute("style","width:100%")
                  }
                }
                  
                }, 1000);
      }else{

    const params = {
                      articleId: this.nameType[0].articleCode,
                      isEn: this.$store.state.language === 'en' ? 1 : 0
                    }
                    articleDetail(params).then((res) => {
                      // console.log(res); 
                        this.lscgznContent=res.data; 
                      // this.list = [res.data]
                      // this.content = 
                    })



      }

    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>


.brief_1{
    font-size: 20px;
    font-weight: 900;
    color: #fff;
}
.Impact {
    font-family: Impact,微软雅黑;
}

.about_us_nav{margin:0px;padding:0px;display:flex;position:absolute;bottom:-20px;width:90%;left:5%;box-shadow:#ebebeb 5px 5px 5px 5px;}
.about_us_nav li{margin:0px;padding:0px;width:25%;text-align:center;height:35px;line-height: 35px;border-right:1px solid #89a128;font-size: 10px;}
 
.show{display:block;}
.item{width:100%;height:50px;margin:0px;display:block;}
.itemActive{background:#89a128;color:#fff;}
.itemNoActive{background:#fff;color:#89a128;}
.hidden{display:none;}
.index{
  margin:0px;
  padding:0px;
  width: 100%;
  min-height: 960px;
}

.el-select .el-input__inner{text-align:center}

.el-input__inner{text-align:center;background-color:#92ab26 !important}

.top{position:relative;width:100%;height:600px;background-size:auto 100%;background-position:0px 0px}

.newsItem{border-bottom:1px solid #628838;overflow:hidden;margin-top:10px;}

.newsItem .facePic{width:100px;}


.navBox{width:150px;}
.navBox li{height:30px;}
.navBox li a{color:#fff;text-align:right;display:block;width:100%;text-decoration: none;}

 
 
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>



// WEBPACK FOOTER //
// src/components/greenGuide.vue